'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DevopsServies from '@/components/technologies/devops-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Automate end-to-end delivery across cloud platforms on-the-go with DevOps Services."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'devops-hero'}
                bgPath={'hero-bg-grunge-red'}
                color="red"
                isRed={true}
            >
                DevOps Services & <div>Solutions</div>
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="DevOps Services & Solution" />
            <ContetVideoSection title="Broaden Your Business Horizons with Agile Delivery Process and Integrated DevOps Services">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        If your ultimate business goal is to improve software quality and to accelerate software release cycle,
                        approaching our DevOps consulting services is your perfect solution. With the perfect combination of
                        practices, tools, and cultural philosophies, Moweb’s DevOps services are designed to boost your
                        organizations software delivery cycle efficiently and effortlessly.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        EOur DevOps consultant aims to maximize your revenue cycle by reducing development time and building
                        bug-free solutions in a way that it ensures a close association with the team at higher velocity.
                        Ultimately, it’s all about getting more competitive and effective in the industry marketplace and DevOps
                        services are designed to bridge the gap between development and operation.
                    </p>
                </>
            </ContetVideoSection>
            <DevopsServies />
            <HireProcess
                bg="bg-devops"
                pageTitle="Hire Custom DevOps Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using DevOps."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for DevOps Consulting?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best DevOps Developers"
                desc="Select from different engagement models to hire DevOps Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
